import { mainStore } from '../stores/MainStore';

export const useUploadHistoryStore = () => {
  return mainStore.uploadHistoryStore;
};
